module.exports = __webpack_public_path__ + "static/media/izlozba (21).49c47f0e.jpg";